import type { StyleRule } from '@archipro-design/aria';
import {
    pxArrayToRem,
    pxToRem,
    SubheaderClassName,
    labelClassName,
    buttonClassName,
} from '@archipro-design/aria';

const PAGE_HEADER_HEIGHT_EXPANDED = 266;
const PAGE_HEADER_INNER_HEIGHT_DEFAULT = 96;

export const ProjectHeaderContainer: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        position: 'relative',
        zIndex: theme.siteVariables.zIndexes.menuItem + 1,

        [`& > div`]: {
            boxShadow: 'none',
        },
    },
});

export const PageHeader: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([0, 18, 0, 18]),

    [theme.screen.laptop]: {
        padding: pxArrayToRem([0, 36, 20, 50]),
        minHeight: pxToRem(PAGE_HEADER_HEIGHT_EXPANDED),
        background: theme.siteVariables.colorScheme.default?.background,
        display: 'grid',
        alignItems: 'end',
    },
});

export const PageHeaderInner: StyleRule = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',

    [theme.screen.laptop]: {
        display: 'grid',
        gridTemplateColumns: `${pxToRem(924)} 1fr`,
        alignItems: 'flex-end',
        minHeight: pxToRem(PAGE_HEADER_INNER_HEIGHT_DEFAULT),
    },
});

export const LeftPane: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        position: 'relative',
    },
});

export const ProfessionalTitle: StyleRule = ({ theme }) => ({
    marginBottom: 0,
    marginTop: 0,

    [theme.screen.laptop]: {
        fontSize: pxToRem(16),
        lineHeight: 1,
        textDecoration: 'underline',
    },
});

export const RightPane: StyleRule = ({ theme }) => ({
    marginTop: theme.siteVariables.spaces['space-16'],
    [theme.screen.laptop]: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        position: 'relative',
        margin: 0,
    },
});

export const ProjectTitle: StyleRule = ({ theme }) => ({
    lineHeight: 1,
    textTransform: 'uppercase',
    margin: 0,
    ['&.' + SubheaderClassName]: {
        letterSpacing: 'normal',
    },
    [theme.screen.laptop]: {
        color: theme.siteVariables.colorScheme.default!.foreground,
        fontSize: pxToRem(22),
    },
});

export const ProjectTitleProfessional: StyleRule = () => ({
    marginTop: pxToRem(6),
    textDecoration: 'underline',
});

export const PointerEventsNone: StyleRule = () => ({
    pointerEvents: 'none',
});

export const BreadCrumb: StyleRule = ({ theme }) => ({
    transform: `translateY(${pxToRem(PAGE_HEADER_INNER_HEIGHT_DEFAULT * -1)})`,

    '& .ui-breadcrumbItem': {
        color: theme.siteVariables.colorScheme.default!.foreground,
    },
});

export const ProjectTitleContainer: StyleRule = () => ({
    display: 'flex',
    flexDirection: 'column',
    gap: pxToRem(9),
    justifyContent: 'flex-end',
});

export const RightPaneInner: StyleRule = () => ({
    display: 'grid',
    gridTemplateColumns: `1fr auto`,
    gridGap: pxToRem(15),
    alignItems: 'end',
    width: '100%',
});

export const SaveButton: StyleRule = () => ({
    display: 'flex',
    alignItems: 'center',
});

export const LinkButton: StyleRule = () => ({
    textDecoration: 'underline',
    '& > span': {
        marginRight: pxToRem(10),
    },
});

export const ViewProfileButton: StyleRule = () => ({
    textDecoration: 'underline',
    '& > span': {
        marginRight: pxToRem(4),
    },
    [`& .${labelClassName}`]: {
        textDecoration: 'underline',
    },
});

export const HeaderButton: StyleRule = ({ theme }) => ({
    [`&.${buttonClassName}`]: {
        padding: pxArrayToRem([8, 20]),
        width: '100%',
        border: 'none',
        outline: `1px solid ${theme.siteVariables.colors.charcoal['250']}`,
        '&:hover': {
            border: 'none',
        },

        [`& .${labelClassName}`]: {
            textTransform: 'uppercase',
            fontSize: pxToRem(15),
            lineHeight: pxToRem(32),
            ...theme.siteVariables.textStyles.Heading.Medium65,
        },
    },
});
